import {useMediaQuery} from '@mui/material';

// NOTE: these should match createTheme()
export const XS_SIZE = 0;
export const SM_SIZE = 600;
export const MD_SIZE = 900;
export const LG_SIZE = 1366;
export const XL_SIZE = 1536;

// equivalent to theme.breakpoints.down/up('sm')
export function useSmOrSmaller() {
  return useMediaQuery(`(max-width: ${SM_SIZE - 1}px)`);
}
export function useSmOrLarger() {
  return useMediaQuery(`(min-width: ${SM_SIZE}px)`);
}

export function useMdOrSmaller() {
  return useMediaQuery(`(max-width: ${MD_SIZE - 1}px)`);
}
export function useMdOrLarger() {
  return useMediaQuery(`(min-width: ${MD_SIZE}px)`);
}

export function useLgOrSmaller() {
  return useMediaQuery(`(max-width: ${LG_SIZE - 1}px)`);
}
export function useLgOrLarger() {
  return useMediaQuery(`(min-width: ${LG_SIZE}px)`);
}

export function useXlOrSmaller() {
  return useMediaQuery(`(max-width: ${XL_SIZE - 1}px)`);
}
export function useXlOrLarger() {
  return useMediaQuery(`(min-width: ${XL_SIZE}px)`);
}

export function useSize<V = string | number | undefined, S extends string = string>({
  bools,
  sizes,
}: {
  bools: boolean[];
  sizes: S[];
}): {size: S; getBySize: (values: Record<S, V>) => V} {
  const size = sizes?.[bools.filter((v) => v).length];
  return {
    size,
    getBySize: (values) => values[size],
  };
}
